export default {"src":"/_next/static/media/new-trees-and-or-shrubs.f13b7b14.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};